'use client';

import { cn } from '@/lib/utils';
import Link from 'next/link';
interface Tab {
  name: string;
  path?: string;
}
interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  className?: string;
  onClick?: (tab: string) => void;
}
export function TabNavigation({
  tabs,
  activeTab,
  className,
  onClick
}: TabNavigationProps) {
  return <div className={cn(`flex w-full text-sm text-center  md:justify-normal overflow-x-scroll scrollbar-none  gap-3 self-stretch border-b-[0.5px] border-black/10 bg-white px-5`, className)} data-sentry-component="TabNavigation" data-sentry-source-file="tab-navigation.tsx">
      {onClick ? tabs.map(tab => <button key={tab.name} type="button" onClick={() => onClick(tab.name)} className={`h-full gap-1.5 self-stretch overflow-hidden py-3 text-sm ${activeTab === tab.name ? 'whitespace-nowrap border-b-2 border-zinc-900 font-semibold text-x-accent-alpha' : 'text-x-secondary'}`}>
              {tab.name}
            </button>) : tabs.map(tab => <Link key={tab.path} href={tab.path as string} className={` self-stretch text-nowrap py-3 sm:text-sm ${activeTab === tab.name ? 'border-b-2 border-zinc-900 font-semibold text-x-accent-alpha' : 'text-x-secondary'}`}>
              {tab.name}
            </Link>)}
    </div>;
}